module.exports = __webpack_public_path__ + "img/layer-card.fc97c92e.svg";